"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBreakdown = exports.getMortgageResult = void 0;
var getMortgageOutputs_1 = require("@okay/okay-mortgage/src/sagas/getMortgageOutputs");
var getMortgageInput_1 = require("@/pages/detail/transfomer/getMortgageInput");
exports.getMortgageResult = function (mortgageState) {
    var mortgageInput = getMortgageInput_1.getMortgageInput(mortgageState);
    var mortgageOutput = getMortgageOutputs_1.getMortgageOutputs(mortgageInput);
    var mortgageOutputStressed = getMortgageOutputs_1.getMortgageOutputs(__assign(__assign({}, mortgageInput), { interestRate: mortgageInput.interestRate + 3 }));
    var stressTestMonthlyIncome = mortgageOutputStressed.monthlyPayment / 0.5;
    var rateTable = mortgageOutput.rateTable;
    var newMortgageState = __assign(__assign({}, mortgageState), { totalExpense: mortgageOutput.totalExpenses, paymentPerMonth: mortgageOutput.monthlyPayment, rateTable: rateTable.map(function (it) { return ({
            rate: it.rate,
            ten: it.byYears.find(function (it2) { return it2.year === 10; }).payment,
            fifteen: it.byYears.find(function (it2) { return it2.year === 15; }).payment,
            twenty: it.byYears.find(function (it2) { return it2.year === 20; }).payment,
            twentyFifth: it.byYears.find(function (it2) { return it2.year === 25; }).payment,
            thirty: it.byYears.find(function (it2) { return it2.year === 30; }).payment,
        }); }), amortizeTable: mortgageOutput.schedule, interest: mortgageOutput.totalInterest, insurance: mortgageOutput.insurance, mortgage: mortgageInput.propertyValue - mortgageInput.downPayment, commission: mortgageOutput.commission, stampDuty: mortgageOutput.totalTax, stressTestMonthlyIncome: stressTestMonthlyIncome, initialCashOutlay: mortgageOutput.totalCashOutlay, error: mortgageOutput.error });
    return newMortgageState;
};
exports.getBreakdown = function (t, mortgage) {
    return [
        { name: t.downPayment, color: 'orange', value: mortgage.downPayment },
        { name: t.mortgage, color: 'yellow', value: mortgage.mortgage },
        { name: t.interest, color: 'green', value: mortgage.interest },
        { name: t.insurance, color: 'purple', value: mortgage.insurance },
        { name: t.stampDuty, color: 'cyan', value: mortgage.stampDuty },
        { name: t.commission, color: 'blue', value: mortgage.commission },
    ].filter(function (it) { return it.value > 0; });
};
